import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { TNotification } from 'app/common/notifications/core/notifications';
import { Notifications } from 'app/common/notifications/ui';

import { useEntityGridNotifications } from './index';

type EntityListNotificationsRenderProps = {
  children: (notifications: ReactNode) => ReactNode;
};
export const EntityGridNotificationsRender = observer(
  ({ children }: EntityListNotificationsRenderProps) => {
    const notifications = useEntityGridNotifications();
    const hasNotifications = notifications.messages.length > 0;

    const onClose = (messageId: Pick<TNotification, 'id'>) =>
      notifications.removeMessage(messageId);

    return hasNotifications ? (
      <>
        {children(
          <Notifications messages={notifications.messages} onClose={onClose} />,
        )}
      </>
    ) : null;
  },
);
